import React from 'react';
import PropTypes from 'prop-types';
import Item from './ListItem';
import * as shapes from '../shapes';

const List = ({ promoCodes, baseUrl, canModify }) => (
  <div className="c-wrapper">
    <div className="u-max-width-1050 u-margin-auto u-mv-">
      <div className="c-table-card c-table-new u-table-layout-fixed" display-if={promoCodes.length}>
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label">Promo Name</div>
          <div className="c-table-card__cell c-label">Value</div>
          <div className="c-table-card__cell c-label">First appointment only</div>
          <div className="c-table-card__cell c-label">One time promo</div>
          <div className="c-table-card__cell c-label">Expiration date</div>
          <div className="c-table-card__cell c-label">Redemptions</div>
          <div className="c-table-card__cell c-label">Total Redemption Value</div>
        </div>
      </div>
      <div className="c-table-card c-table-new u-table-layout-fixed" display-if={promoCodes.length}>
        {promoCodes.map(promoCode => (
          <Item
            promoCode={promoCode}
            key={promoCode.id}
            baseUrl={baseUrl}
            disabled={!canModify}
          />
        ))}
      </div>
      <div className="c-heading c-heading--small u-mt" display-if={!promoCodes.length}>
        No promo codes are currently set up. To add a promo code please click on the
        Add Promo Code button.
      </div>
    </div>
  </div>
);
List.propTypes = {
  promoCodes: shapes.promoCodes,
  baseUrl: shapes.url,
  canModify: PropTypes.bool,
};
List.defaultProps = {
  promoCodes: [],
  baseUrl: '/settings/taxes',
  canModify: true,
};

export default List;
